module.exports = __webpack_public_path__ + "static/media/Julia_P@3x.a383afff.jpg";